import React, { useEffect, useState } from 'react';
import '../../styles/dashboard.css';
import { useSelector, useDispatch } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import moment from 'moment';

import Lottie from 'react-lottie-player';
import announcementLottie from '../../assets/lottie/announcement.json';
import congratulationSuccessLottie from '../../assets/lottie/congratulation-success.json';
import refer from '../../assets/images/refer.svg';

import crown from '../../assets/images/crown.svg';

import upcoming from '../../assets/images/upcoming.svg';
import eventBg from '../../assets/images/eventbg.svg';

import fire from '../../assets/images/fire.svg';

import assignmentIcon from '../../assets/images/assign.svg';

import { FiArrowRight } from 'react-icons/fi';

import { FaArrowCircleRight } from 'react-icons/fa';

import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import rehypeRaw from 'rehype-raw';
import remarkHTML from 'remark-html';

import { BsFillPersonFill } from 'react-icons/bs';

import {
	fetchAllModules,
	fetchModuleQuestions,
	handleSwitch,
	updateModules,
} from '../../redux/modules/moduleSlice';
import Chart from '../../components/Chart';
import {
	checkIfCommunityEnabled,
	fetchChartData,
} from '../../redux/user/userSlice';
import {
	fetchMeetingIDs,
	getTotalAssignmentSolved,
	setMeetingId,
} from '../../redux/course/courseSlice';
import { fetchAllContests } from '../../redux/contest/contestSlice';

import { services } from '../../apis';
import Cookies from 'js-cookie';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import ReactMarkdown from 'react-markdown';
import StudentLectureFeedbackPopUp from '../../components/studentLectureFeedbackPopUp/studentLectureFeedbackPopUp';
import { engagements } from '../../engagements';
import EffortScore from '../../components/EffortScore';
import EffortModal from '../../components/EffortModal';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
	<Tooltip
		{...props}
		classes={{ popper: className }}
	/>
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: theme.palette.common.white,
		color: 'rgba(0, 0, 0, 0.87)',
		boxShadow: theme.shadows[1],
		fontSize: 11,
	},
}));

const Dashboard = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const dummy =
		'https://cdn.pixabay.com/photo/2016/09/01/08/24/smiley-1635449_1280.png';

	const [notice, setNotice] = useState(true);
	const [noticeData, setNoticeData] = useState('');
	const [solved, setSolved] = useState(true);

	const startZoomMeeting = async (meetingId: string) =>
		await services.courseService.fetchStartUrl(meetingId);
	const startZoomMeetingForStudents = async (meetingId: string) =>
		await services.courseService.fetchStartUrlForStudents(
			meetingId,
			user.firstName,
			user.lastName,
			user.email,
		);

	const courseState = useSelector((state: any) => state.course);
	const {
		latestAssignment,
		courseID,
		course,
		allCourses,
		courseName,
		leaderboard,
		latestAssignmentData,
		totalAssignmentQuestions,
		totalSolvedAssignmentQuestions,
		totalAssignmentQuestionOverall,
		totalSolvedAssignmentQuestionOverall,
		upcomingMeetings,
	} = courseState;

	const moduleState = useSelector((state: any) => state.module);
	const contestState = useSelector((state: any) => state.contest);

	const { currentContest } = contestState;

	const userState = useSelector((state: any) => state.user);
	const {
		streak,
		chartData,
		user,
		latestCourseName,
		announcement,
		latestCourseID,
		communityEnabled,
	} = userState;

	const instructor =
		user !== null
			? user.roles.find((role: any) => role == 'instructor')
			: undefined;
	const role = instructor !== undefined ? 1 : 0;
	const [latestModule, setLatestModule] = useState<any>({
		name: undefined,
		solved: undefined,
		totalQuestions: undefined,
	});
	const localAccioToken = Cookies.get('acciojobs-token');
	const [latestModuleStatus, setLatestModuleStatus] = useState(false);
	console.log(
		'a;jlsdfhl;aksdjhflksadhfkljasdhfjkslatestCourseID',
		latestCourseID
	);
	const [lectureBtn, setLectureBtn] = useState(true);
	const [doubtBtn, setDoubtBtn] = useState(true);
	const [showLecture, setShowLecture] = useState(true);
	const [showDoubt, setShowDoubt] = useState(true);
	const [upcomingLectures, setUpcomingLectures] = useState([]);
	const [upcomingDoubts, setUpcomingDoubts] = useState([]);

	useEffect(() => {
		console.log('asd', user);
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		user != null ? dispatch(checkIfCommunityEnabled()) : null;
	}, [user]);

	useEffect(() => {
		if (upcomingMeetings !== null) {
			const curr = moment().add('15', 'minutes');
			const currDate = moment().format('DD MMM YYYY');
			const currExact = moment();
			console.log('upcomingMeetings', upcomingMeetings);
			let upcomingLectureTemp: any[] = [];
			for (let i = 0; i < upcomingMeetings.lecture.length; i++) {
				let temp = { ...upcomingMeetings.lecture[i] };
				let el = upcomingMeetings.lecture[i];
				if (currDate === moment(el.start_time).format('DD MMM YYYY')) {
					if (currExact < moment(el.end_time)) {
						temp.active = curr <= moment(el.start_time);
						upcomingLectureTemp.push(temp);
					} else {
						temp.active = el.isLive;
						upcomingLectureTemp.push(temp);
					}
				} else if (el.isLive) {
					temp.active = el.isLive;
					upcomingLectureTemp.push(temp);
				}
			}
			// @ts-ignore
			setUpcomingLectures(upcomingLectureTemp);


			let upcomingDoubtTemp: any[] = [];
			for (let i = 0; i < upcomingMeetings.doubt.length; i++) {
				let temp = { ...upcomingMeetings.doubt[i] };
				let el = upcomingMeetings.doubt[i];
				if (currDate === moment(el.start_time).format('DD MMM YYYY')) {
					if (currExact < moment(el.end_time)) {
						temp.active = curr <= moment(el.start_time);
						upcomingDoubtTemp.push(temp);
					} else {
						temp.active = el.isLive;
						upcomingDoubtTemp.push(temp);
					}
				} else if (el.isLive) {
					temp.active = el.isLive;
					upcomingDoubtTemp.push(temp);
				}
			}

			// @ts-ignore
			setUpcomingDoubts(upcomingDoubtTemp);

			// const upcomingLectureTemp = upcomingMeetings.lecture.filter((el: any) => {
			// 	let temp = { ...el };
			// 	if (currDate === moment(el.start_time).format('DD MMM YYYY')) {
			// 		if (currExact < moment(el.end_time)) {
			// 			temp.active = curr <= moment(el.start_time);
			// 			return temp;
			// 		} else {
			// 			temp.active = el.isLive;
			// 			return temp;
			// 		}
			// 	} else if (el.isLive) {
			// 		temp.active = el.isLive;
			// 		return temp;
			// 	}
			// });
			console.log('upcomingLectureTemp', upcomingLectureTemp);


			// const upcomingDoubtTemp = upcomingMeetings.doubt.filter((el: any) => {
			// 	let temp = { ...el };
			// 	if (currDate === moment(el.start_time).format('DD MMM YYYY')) {
			// 		if (currExact < moment(el.end_time)) {
			// 			temp.active = curr <= moment(el.start_time);
			// 			return temp;
			// 		} else {
			// 			temp.active = el.isLive;
			// 			return temp;
			// 		}
			// 	} else if (el.isLive) {
			// 		temp.active = el.isLive;
			// 		return temp;
			// 	}
			// });

			// if (upcomingMeetings.lecture.length !== 0) {
			// 		curr.format('HH:mm:ss DD MMM YYYY'),
			// 		moment(upcomingMeetings.lecture[0].start_time).format(
			// 			'HH:mm:ss DD MMM YYYY',
			// 		),
			// 	);
			// 	if (curr > moment(upcomingMeetings.lecture[0].start_time)) {
			// 		setLectureBtn(false);
			// 		if (
			// 			currExact >
			// 			moment(upcomingMeetings.lecture[0].end_time) &&
			// 			!upcomingMeetings.lecture[0].isLive
			// 		) {
			// 			setShowLecture(false);
			// 		}
			// 	}
			// }
			// if (upcomingMeetings.doubt.length !== 0) {
			// 	if (curr > moment(upcomingMeetings.doubt[0].start_time)) {
			// 		setDoubtBtn(false);
			// 		if (
			// 			currExact >
			// 			moment(upcomingMeetings.doubt[0].end_time) &&
			// 			!upcomingMeetings.doubt[0].isLive
			// 		) {
			// 			setShowLecture(false);
			// 		}
			// 	}
			// }
		}
	}, [upcomingMeetings]);

	useEffect(() => {
		if (chartData.length == 0) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			dispatch(fetchChartData());
		}
	}, [chartData]);


	// useEffect(() => {
	// 	if (courseID !== null) {
	// 		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// 		// @ts-ignore
	// 		// dispatch(fetchMeetingIDs(courseID));
	// 		// setLatestModuleStatus(true);
	// 	}
	// }, [courseID]);

	const setZoomMeetingId = (
		meetingId: string,
		start_url: string,
		title: string,
	) => {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		dispatch(setMeetingId(meetingId));
		const myWindow = window.open('', new Date().getTime().toString());
		if (role === 0) {
			startZoomMeetingForStudents(meetingId)
				.then((res) => {
					engagements.courseEngagement.joinClass(title, meetingId);
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					//@ts-ignore
					myWindow.location.href = res.join_url;
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					//@ts-ignore
					myWindow.focus();
				})
				.catch((e) =>
					alert(
						'Some error occured in joining the class. Please try again',
					),
				);
		} else {
			startZoomMeeting(meetingId)
				.then((res) => {
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					//@ts-ignore
					myWindow.location.href = res;
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					//@ts-ignore
					myWindow.focus();
				})
				.catch((e) =>
					alert(
						'Some error occured in joining the class. Please try again',
					),
				);
		}
	};

	useEffect(() => {
		if (announcement !== null && announcement.userCourseMapping) {
			if (announcement.announcement.type === 'ANNOUNCEMENT') {
				setNotice(true);
			} else setNotice(false);
			setNoticeData(announcement.announcement.text);
		}
	}, [announcement]);

	const [isEffortModelOpened, setIsEffortModelOpened] = useState(false);

	return (
		<div className={'dashboard'}>
			<StudentLectureFeedbackPopUp />

			{isEffortModelOpened ? (
				<div className={'effort-model-overlay'}>
					<EffortModal closeFunction={setIsEffortModelOpened} />
				</div>
			) : null}
			<div className={'column-1'}>
				<p className={'welcome'}>
					<span>Welcome Back</span>{' '}
					{user !== null ? user.firstName : null}
				</p>
				<div className={'notice-comp'}>
					{notice ? (
						<div className={'notice-green'}>
							<div className={'container-1'}>
								<ReactMarkdown
									className={`markdown-body`}
									rehypePlugins={[
										[rehypeHighlight],
										[rehypeRaw],
									]}
									remarkPlugins={[remarkGfm, remarkHTML]}
								>
									{noticeData}
								</ReactMarkdown>
							</div>

							<Lottie
								loop={false}
								animationData={announcementLottie}
								play
							/>
						</div>
					) : (
						<div className={'notice-green notice-yellow'}>
							<div className={'container-1'}>
								<ReactMarkdown
									className={`markdown-body`}
									rehypePlugins={[
										[rehypeHighlight],
										[rehypeRaw],
									]}
									remarkPlugins={[remarkGfm, remarkHTML]}
								>
									{noticeData}
								</ReactMarkdown>
							</div>

							<Lottie
								loop={false}
								animationData={congratulationSuccessLottie}
								play
							/>
						</div>
					)}
				</div>
				<div className={'latest-module'}>
					<div className={'module-marking'}>{latestCourseName}</div>
					<div className={'latest-module-content-container'}>
						{latestAssignmentData !== null ? (
							<>
								<div className={'latest-module-content'}>
									<div className={'module-data'}>
										<div className={'date'}>
											<p>
												{moment(
													latestAssignmentData,
												).format('MMM')}
											</p>
											<h5>
												{moment(
													latestAssignmentData,
												).format('DD')}
											</h5>
										</div>
										<div className={'module-info'}>
											<h3>
												{
													latestAssignmentData.module
														.name
												}
											</h3>
											<p>
												{latestAssignmentData.soleved} /{' '}
												{
													latestAssignmentData.totalQuestions
												}{' '}
												Solved
											</p>
										</div>
									</div>
									<button
										className={`${
											latestAssignmentData.completed
												? 'question-solved-btn'
												: 'question-solve-btn'
										}`}
										onClick={() => navigate('/modules')}
									>
										{' '}
										{latestAssignmentData.completed ? (
											<>Solved</>
										) : (
											<>
												Start Solving
												<FiArrowRight />
											</>
										)}
									</button>
								</div>
								<div className={'progress-bar'}>
									<span
										style={{
											width: `${
												(latestAssignmentData.soleved /
													latestAssignmentData.totalQuestions) *
												100
											}%`,
										}}
									></span>
								</div>
							</>
						) : null}
					</div>
				</div>
				{/* <div className={'weak-topic-analysis'}>
					<h3>Weak Topic Analysis</h3>
					<p>
						Lorem ipsum dolor sit amet, consectetur adipiscing elit.
						Sed eget urna in elit mollis ornare. Donec velit massa,
						aliquam nec tempor sit amet, faucibus ut sem. Nam eu
						ipsum consectetur
					</p>
					<select>
						<option>Select Module</option>
					</select>
				</div> */}
				{latestCourseID !== null ? (
					<EffortScore openEffortModal={setIsEffortModelOpened} />
				) : null}
				<Chart dataset={chartData} />
				{/* <div className={'refer'}>
					<div className={'refer-content'}>
						<h3>Tell your friends about us !</h3>
						<p>
							Refer your friends and earn huge discounts on your
							course The more the merrier !
						</p>
						<button>
							Refer now <FaArrowCircleRight />
						</button>
					</div>
					<img
					src={refer}
						alt={'refer and earn'}
					/>
				</div> */}
			</div>
			<div className={'column-2'}>
				<div className={'upcoming-event'}>
					{upcomingMeetings !== null &&
					(upcomingLectures.length !== 0 ||
						upcomingDoubts.length !== 0) ? (
						<>
							<h3 className={'upcoming-heading'}>
								<span>Upcoming</span> Class
							</h3>
							{upcomingLectures.map((el: any) => {

								return (
									<div className={'event'}>
										<div
											className={
												'upcoming-event-date'
											}
										>
											<img
												src={upcoming}
												alt=''
											/>
											<div
												className={
													'upcoming-event-date-data'
												}
											>
														<span>
															{moment(
																el.start_time,
															).format('MMM')}
														</span>
												<p>
													{moment(
														el.start_time,
													).format('DD')}
												</p>
											</div>
										</div>
										<div
											className={'event-details'}
										>
											<h3>{el.title}</h3>
											<p>
												{moment(
													el.start_time,
												).format('hh:mm A')}
											</p>
											<button
												disabled={el.active}
												onClick={() =>
													setZoomMeetingId(
														el.roomId,
														el.start_url,
														el.title,
													)
												}
											>
												Join Now{' '}
												<FiArrowRight />
											</button>
										</div>
									</div>
								);
							})}
							<span className={'divider'}></span>

							{upcomingDoubts.map((el: any) => {

								return (
									<div className={'event'}>
										<div
											className={
												'upcoming-event-date'
											}
										>
											<img
												src={upcoming}
												alt={''}
											/>
											<div
												className={
													'upcoming-event-date-data'
												}
											>
														<span>
															{moment(
																el.start_time,
															).format('MMM')}
														</span>
												<p>
													{moment(
														el.start_time,
													).format('DD')}
												</p>
											</div>
										</div>
										<div
											className={'event-details'}
										>
											<h3>{el.title}</h3>
											<p>
												{moment(
													el.start_time,
												).format('hh:mm A')}
											</p>
											<button
												disabled={el.active}
												onClick={() =>
													setZoomMeetingId(
														el.roomId,
														el.start_url,
														el.title,
													)
												}
											>
												Join Now{' '}
												<FiArrowRight />
											</button>
										</div>
									</div>
								);
							})}
						</>
					) : (
						<>
							<h3 className={'upcoming-heading'}>
								<span>Upcoming</span> Class
							</h3>

							<div className={'event'}>
								<p className={'class-to-be-updated'}>
									Class details will be updated soon!
								</p>
							</div>
						</>
					)}
				</div>
				{currentContest !== null ? (
					<div className={'upcoming-event contest-event'}>
						<h3 className={'upcoming-heading'}>
							<span>Your Contest</span>
						</h3>
						<div className={'event'}>
							<div className={'upcoming-event-date'}>
								<img
									src={eventBg}
									alt=''
								/>
								<div className={'upcoming-event-date-data'}>
									<span>
										{moment(
											currentContest.startTime,
										).format('MMM')}
									</span>
									<p>
										{moment(
											currentContest.startTime,
										).format('DD')}
									</p>
								</div>
							</div>
							<div className={'event-details'}>
								<h3>{currentContest.name}</h3>
								<p>
									{moment(currentContest.startTime).format(
										'hh:mm A',
									)}
								</p>
								<button
									onClick={() =>
										currentContest.projectFlag
											? window.open(
													`https://course.acciojob.com/start-project?project=${currentContest.id}`
											  )
											: window.open(
													`https://contest.acciojob.com?contestID=${currentContest.contestId}`
											  )
									}
								>
									Start <FiArrowRight />
								</button>
							</div>
						</div>
						<div
							style={{
								fontSize: '12px',
								paddingBottom: '10px',
							}}
						>
							{currentContest.flag === 'ongoing' ? (
								<u>Your test is ongoing! Please join!</u>
							) : (
								<u>
									Available between{' '}
									{moment(currentContest.startTime).format(
										' hh:mm A DD MMM',
									)}{' '}
									-{' '}
									{moment(currentContest.endTime).format(
										' hh:mm A DD MMM',
									)}
								</u>
							)}
						</div>
					</div>
				) : null}
				{communityEnabled && (
					<div className={'user-meta-info'}>
						<div className={'consistency upcoming-event'}>
							<h5>
								<span style={{ color: '#2F80ED' }}>Never</span>{' '}
								miss
								<br />
								a course update <br />
								{/* <span style={{ color: '#2F80ED' }}>again</span> */}
							</h5>
							<a
								href={
									'https://community.acciojob.com/oauth2/callback#access_token=' +
									localAccioToken
								}
								rel="noreferrer"
								target="_blank"
							>
								<button>
									Enter Community <FiArrowRight />
								</button>
							</a>
						</div>
					</div>
				)}
				{leaderboard.length === 11 ? (
					<div className={'leaderboard'}>
						<div className={'leaderboard-head'}>
							<h1>Leaderboard</h1>
							<div className={'user-score'}>
								<h3>{leaderboard[10].rank}</h3>
								<span>{leaderboard[10].total_score} pt</span>
								{/*<img*/}
								{/*	src={`${window.location.origin}/defaults/Avatar.svg`}*/}
								{/*/>*/}

								<p className={'user-first-letter'}>
									{leaderboard[10].name[0]}
								</p>
							</div>
						</div>

						<div className={'leaderboard-content'}>
							<div className={'leader-2'}>
								{/*<img*/}
								{/*	className={'leader-image-2'}*/}
								{/*	src={*/}
								{/*		leaderboard[1].imageUrl !== null*/}
								{/*			? leaderboard[1].imageUrl*/}
								{/*			: dummy*/}
								{/*	}*/}
								{/*	alt={'leader'}*/}
								{/*/>*/}
								<p className={'leader-image-2'}>
									{leaderboard[1].name[0]}
								</p>
								<h1>
									{leaderboard[1].name !== ''
										? leaderboard[1].name
										: 'A'}
								</h1>
								<div className={'leader-score'}>
									<span>2</span>
									{leaderboard[1].score} pts
								</div>
								<img
									className={'stage'}
									src={`${window.location.origin}/defaults/leader2.svg`}
								/>
							</div>
							<div className={'leader-1'}>
								<img
									src={crown}
									alt={'crown'}
								/>
								{/*<img*/}
								{/*	className={'leader-image-2'}*/}
								{/*	src={*/}
								{/*		leaderboard[0].imageUrl !== null*/}
								{/*			? leaderboard[0].imageUrl*/}
								{/*			: dummy*/}
								{/*	}*/}
								{/*	alt={'leader'}*/}
								{/*/>*/}
								<p className={'leader-image-2'}>
									{leaderboard[0].name[0]}
								</p>
								<h1>
									{leaderboard[0].name !== ''
										? leaderboard[0].name
										: 'A'}
								</h1>
								<div className={'leader-score'}>
									<span>1</span>
									{leaderboard[0].score} pts
								</div>
								<img
									className={'stage'}
									src={`${window.location.origin}/defaults/leader2.svg`}
								/>
							</div>
							<div className={'leader-3'}>
								{/*<img*/}
								{/*	className={'leader-image-2'}*/}
								{/*	src={*/}
								{/*		leaderboard[2].imageUrl !== null*/}
								{/*			? leaderboard[2].imageUrl*/}
								{/*			: dummy*/}
								{/*	}*/}
								{/*	alt={'leader'}*/}
								{/*/>*/}
								<p className={'leader-image-2'}>
									{leaderboard[2].name[0]}
								</p>
								<h1>
									{leaderboard[2].name !== ''
										? leaderboard[2].name
										: 'A'}
								</h1>
								<div className={'leader-score'}>
									<span>3</span>
									{leaderboard[2].score} pts
								</div>
								<img
									className={'stage'}
									src={`${window.location.origin}/defaults/leader2.svg`}
								/>
							</div>
						</div>
						<ul className={'leaderboard-list'}>
							{leaderboard.map((el: any, index: number) => {
								if (index < 10 && index > 2)
									return (
										<li
											key={index}
											className={'leader-info'}
										>
											<span className={'leader-rank'}>
												{index + 1}
											</span>
											<span className={'leader-name'}>
												{el.name}
											</span>
											<span
												className={'leader-score-list'}
											>
												{el.score}
											</span>
										</li>
									);
							})}
							<li
								key={leaderboard[10].rank}
								className={
									'leader-info user-leaderboard-profile'
								}
							>
								<span className={'leader-rank'}>
									{leaderboard[10].rank}
								</span>
								<span className={'leader-name'}>
									{leaderboard[10].name} (YOU)
								</span>
								<span className={'leader-score-list'}>
									{leaderboard[10].total_score}
								</span>
							</li>
						</ul>
					</div>
				) : null}
			</div>
		</div>
	);
};

export default Dashboard;
